import React from "react";
import { Stack, Text } from "@fluentui/react";
import { childrenGap } from "../common/Constants";
import { numberWithCommas } from "../../services/UtilService";

export interface ReportStatusCardProps {
  status: number | string;
  count: number;
  isReportStatus: boolean;
  isMomStatus?: boolean;
  isSlaMatrix?: boolean;
  isReportStatusClickDisabled?: boolean;
}

const REPORT_STATUS_DICT: { [Key: number]: string } = {
  0: "Submission Awaiting",
  1: `Submitted by Ops Team`,
  2: "Approved by DC Manager",
  3: "Approved by MIS",
  4: "Approved by CEM",
  5: "Send Email to Customer",
  "-2": "Rejected by DC Manager",
  "-3": "Rejected by MIS",
  "-4": "Rejected by CEM",
  10: "Total Reports",
};

const dashBoardColor: { [key: number]: string } = {
  0: "dashboard-awaiting-card",
  1: "dashboard-submitted-card",
  2: "dashboard-approved-dc-card",
  3: "dashboard-approved-mis-card",
  4: "dashboard-approved-cem-card",
  5: "dashboard-send-email-card",
  "-2": "dashboard-rejected-dc-card",
  "-3": "dashboard-rejected-mis-card",
  "-4": "dashboard-rejected-cem-card",
  10: "dashboard-total-report",
};

const MOM_STATUS_DICT: { [Key: string]: string } = {
  open: "Open",
  // pending: "Pending",
  wip: "Work In Progress",
  closed: "Closed",
  total: "Total MOM Points",
  totalMOM: "Total MOM",
  "under-observation": "Under Observation"
};

const dashBoardColorForMomStatus: { [key: string]: string } = {
  open: "dashboard-awaiting-card",
  // pending: "dashboard-awaiting-card",
  wip: "dashboard-approved-cem-card",
  closed: "dashboard-rejected-dc-card",
  total: "dashboard-approved-dc-card",
  totalMOM: "dashboard-submitted-card",
  "under-observation": "dashboard-total-report",
};

const SLA_MATRIX_DICT: { [Key: string]: string } = {
  temp: "Temperature",
  rh: "Humidity",
};

const dashBoardColorForSlaMatrix: { [key: string]: string } = {
  temp: "dashboard-awaiting-card",
  rh: "dashboard-submitted-card",
};

const SENSOR_DIC: { [Key: string]: string } = {
  schneider: "Schneider",
  "delta-snmp": "Delta SNMP",
  siemens: "Siemens",
  tridium: "Tridium",
  "ganesh-computer": "Ganesh Computer",
  "ebi-excel": "Ebi Excel",
  "delta-pg": "Delta PG",
  datson: "Datson",
  vertiv: "Vertiv",
  azbil: "Azbil",
};

const dashBoardColorForSensor: { [key: string]: string } = {
  "ganesh-computer": "dashboard-awaiting-card",
  azbil: "dashboard-submitted-card",
  tridium: "dashboard-approved-dc-card",
  siemens: "dashboard-approved-cem-card",
  "delta-snmp": "dashboard-rejected-dc-card",
  "delta-pg": "dashboard-rejected-cem-card",
  "ebi-excel": "dashboard-total-report",
  schneider: "dashboard-awaiting-card",
};

const ReportStatusCard: React.FC<ReportStatusCardProps> = ({
  status,
  count,
  isReportStatus,
  isMomStatus,
  isSlaMatrix,
  isReportStatusClickDisabled
}) => {
  return (
    <React.Fragment>
      {isReportStatus ? (
        <div
          className={`${status === 10
            ? `status-count-card total-count-card`
            : ` status-count-card`
            } ms-motion-scaleDownIn p-16 ${!isReportStatusClickDisabled && 'pointer'}`}
        >
          <Stack tokens={childrenGap}>
            <div>
              <Text className="count-card-title">
                {REPORT_STATUS_DICT[status as number]}
              </Text>
            </div>
            <div className={dashBoardColor[status as number]}>
              <Text variant="xxLarge" styles={{ root: { fontWeight: 500 } }}>
                {numberWithCommas(String(count))}
              </Text>
            </div>
          </Stack>
        </div>
      ) : isMomStatus ? (
        <div
          // className={`status-count-card ms-motion-scaleDownIn p-16 ${["pending", "closed", "wip", "total"].includes(status as string)
          // className={`status-count-card ms-motion-scaleDownIn p-16 ${["open", "closed", "wip", "total"].includes(status as string)
          className={`status-count-card ms-motion-scaleDownIn p-16 ${["open", "closed", "wip", "total", "totalMOM"].includes(status as string)
            ? "pointer"
            : ""
            }`}
        >
          <Stack tokens={childrenGap}>
            <div>
              <Text className="count-card-title">
                {MOM_STATUS_DICT[status as string]}
              </Text>
            </div>
            <div className={dashBoardColorForMomStatus[status as string]}>
              <Text variant="xxLarge" styles={{ root: { fontWeight: 500 } }}>
                {numberWithCommas(String(count))}
              </Text>
            </div>
          </Stack>
        </div>
      ) : isSlaMatrix ? (
        <div className={`status-count-card ms-motion-scaleDownIn p-16 pointer`}>
          <Stack tokens={childrenGap}>
            <div>
              <Text className="count-card-title">
                {SLA_MATRIX_DICT[status as string]}
              </Text>
            </div>
            <div className={dashBoardColorForSlaMatrix[status as string]}>
              <Text variant="xxLarge" styles={{ root: { fontWeight: 500 } }}>
                {numberWithCommas(String(count))}
              </Text>
            </div>
          </Stack>
        </div>
      ) : (
        <div className={`status-count-card ms-motion-scaleDownIn p-16`}>
          <Stack tokens={childrenGap}>
            <div>
              <Text className="count-card-title">
                {SENSOR_DIC[status as string]}
              </Text>
            </div>
            <div className={dashBoardColorForSensor[status as string]}>
              <Text variant="xxLarge" styles={{ root: { fontWeight: 500 } }}>
                {numberWithCommas(String(count))}
              </Text>
            </div>
          </Stack>
        </div>
      )}
    </React.Fragment>
  );
};

export default ReportStatusCard;
